import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import createCache from '@emotion/cache';
import { CacheProvider as EmotionCacheProvider } from '@emotion/react';
import { useState, useEffect } from 'react';
import { emotionRemToPx } from '@astrumu/core-ui-branding';
import { ShadowRoot } from '../ShadowRoot/index.js';
import { useShadowDOM } from '../hooks/useShadowDOM/index.js';
export const ShadowDOM = ({ children, isAttached = true }) => {
    const [emotionCache, setEmotionCache] = useState(null);
    const { shadowRoot } = useShadowDOM();
    function setEmotionStyles(ref) {
        if (ref && !emotionCache) {
            const createdEmotionWithRef = createCache({
                key: 'shadow-emotion',
                stylisPlugins: [emotionRemToPx()],
                container: ref
            });
            setEmotionCache(createdEmotionWithRef);
        }
    }
    useEffect(() => {
        window.rootElement = shadowRoot || document;
    }, []);
    if (isAttached) {
        return (_jsxs(ShadowRoot, { children: [_jsx("div", { id: "shadow-root-styles", ref: ref => setEmotionStyles(ref) }), emotionCache && (_jsx(EmotionCacheProvider, { value: emotionCache, children: _jsx("div", { id: "shadow-root", children: children }) }))] }));
    }
    return _jsx(_Fragment, { children: children });
};
//# sourceMappingURL=index.js.map